module.exports = __webpack_public_path__ + "5486c20237b114d0b3333c70afd40cb7.svg";